"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventAction = void 0;
var EventAction;
(function (EventAction) {
    EventAction["AddToWishlist"] = "AddToWishlist";
    EventAction["RemoveFromWishlist"] = "RemoveFromWishlist";
    EventAction["BoxClick"] = "BoxClick";
    EventAction["TextClick"] = "TextClick";
    EventAction["SelectPaymentMethod"] = "SelectPaymentMethod";
    EventAction["HoverIn"] = "HoverIn";
    EventAction["Click"] = "Click";
    EventAction["Error"] = "Error";
})(EventAction || (exports.EventAction = EventAction = {}));
//# sourceMappingURL=EventAction.js.map